import { Theme } from '@mui/material';
import { differenceInDays, parseISO } from 'date-fns';

export const getActivityStatus = (
  lastActivity: string | null,
  isSelfRegistered: boolean,
  theme: Theme
): { text: string; color: string } => {
  const now = new Date();
  const days = lastActivity
    ? differenceInDays(now, parseISO(lastActivity))
    : null;

  if (days === null) {
    return isSelfRegistered
      ? { text: 'Registered', color: theme.palette.colors.brown }
      : { text: 'Invited', color: theme.palette.colors.orange100 };
  }

  if (days === 0) return { text: 'Active today', color: theme.palette.colors.gray400 };
  if (days === 1) return { text: 'Active yesterday', color: theme.palette.colors.gray400 };
  if (days <= 3)
    return { text: `Active ${days} days ago`, color: theme.palette.colors.gray400 };
  if (days <= 7)
    return { text: `Active in last 7 days`, color: theme.palette.colors.gray400 };
  if (days <= 30)
    return { text: `Active in last 30 days`, color: theme.palette.colors.gray400 };

  return { text: `Active 30+ days ago`, color: theme.palette.colors.gray400 };
};
